'use strict';

const sendCustomerHashToServiceWorker = function(info) {
    navigator.serviceWorker.ready.then(function(registration) {
        registration.active.postMessage({
            type: 'customerHash',
            hash: info.hash,
            loginState: info.userLoginState
        });
    })
}

if ('serviceWorker' in navigator) {
    let currentLocale = window.SFRA.ServiceWorkerPreference.currentLocale;
    let swCacheVersion = window.SFRA.ServiceWorkerPreference.swCacheVersion;
    navigator.serviceWorker.register('/' + currentLocale + '/serviceWorker.js?v=' + swCacheVersion, {
        scope: '/' + currentLocale + '/'
    }).then(function() {
        if (window.SFRA.ServiceWorkerPreference.akamaiEnabled) {
            var urlElement = document.querySelector('link[rel=fetch-customer-hash]');
            var url = urlElement ? urlElement.getAttribute('href') : null;
            // get customer hash from server
            if (url) {
                fetch(url).then(function(response) {
                    response.json().then(function(hashInfo) {
                        sendCustomerHashToServiceWorker(hashInfo);
                    })
                });
            }
        }
    })
}
